/**
 * Capitalizes the first letter of a string
 * @param {string} str - The string to capitalize
 * @returns {string} String with first letter capitalized
 */
export const capitalize = (str) => {
  if (!str || typeof str !== 'string') {
    return '';
  }
  
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Capitalizes the first letter and converts the rest to lowercase
 * @param {string} str - The string to format
 * @returns {string} String with first letter capitalized and rest lowercase
 */
export const capitalizeFirst = (str) => {
  if (!str || typeof str !== 'string') {
    return '';
  }
  
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

/**
 * Capitalizes the first letter of each word in a string
 * @param {string} str - The string to format
 * @returns {string} String with each word capitalized
 */
export const capitalizeWords = (str) => {
  if (!str || typeof str !== 'string') {
    return '';
  }
  
  return str.split(' ').map(word => capitalize(word)).join(' ');
};

// Usage examples:
/*
import { capitalize, capitalizeFirst, capitalizeWords } from './capitalize-utils';

capitalize('hello world');        // "Hello world"
capitalize('HELLO WORLD');        // "HELLO WORLD"

capitalizeFirst('hello world');   // "Hello world"
capitalizeFirst('HELLO WORLD');   // "Hello world"

capitalizeWords('hello world');   // "Hello World"
capitalizeWords('HELLO WORLD');   // "HELLO WORLD"

// Edge cases handled:
capitalize('');                   // ""
capitalize(null);                 // ""
capitalize('a');                  // "A"
*/